import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useNotifyError } from '~/features/hooks/useNotifyError'
import { GET_ALL_MODELS_QUERY_KEY } from '~/features/models/models-list/hooks/useGetAllModels'
import { supabaseApi } from '~/supabase/api'
import { ModelV2 } from '~/supabase/types'

export const useImportModels = () => {
  const queryClient = useQueryClient()

  const { mutate: notifyError } = useNotifyError()

  return useMutation({
    mutationKey: ['import-models'],
    mutationFn: async (payload: Omit<ModelV2, 'id' | 'created_at' | 'updated_at'>[]) => {
      const { error } = await supabaseApi.from('models_v2').insert(payload)

      if (error) {
        toast.error('Upload failed.')
        notifyError({
          message: 'Upload failed',
          data: { payload },
          error,
          function: 'useImportModels',
        })
        throw error
      } else {
        toast.success('Upload successful')
        queryClient.invalidateQueries({ queryKey: [GET_ALL_MODELS_QUERY_KEY] })
      }
    },
  })
}
